import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import {
  addMemberToCohort,
  createCohortProgram,
  getDigitalCoachingTrainers,
  getWellnessPrograms,
  removeMemberFromCohort,
  setCohortForm,
  updateCohortProgram,
  updateCompanyCohort
} from '../../../modules/Company';
import { LoadingSpinnerPage } from '../../../components/atomic/Loaders/LoadingSpinner';
import Detail from './Detail';
import Members from './Members';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`;

const Header = styled.div`
  margin: 20px;
  font-size: 20px;
  font-weight: 600;
`;

class CohortDetail extends Component {
  constructor(props) {
    super(props);
    const {
      companyState: {
        companies,
        companyCohorts,
        companyUsers
      },
      location: {
        state
      },
      match: {
        params: {
          cid,
          uid
        }
      }
    } = props;

    const thisCompany = state && state.company
      ? state.company
      : companies.find(item => item.id === parseInt(uid));

    const thisCohort = state && state.cohort
      ? state.cohort
      : companyCohorts[uid] && companyCohorts[uid].find(item => item.id === parseInt(cid));

    const unassignedUsers = companyUsers[uid].filter(user => !thisCohort.members.find(member => member.id === user.id));

    this.state = {
      cohort: thisCohort,
      company: thisCompany,
      programs: [],
      trainers: [],
      unassignedUsers,
    };
  }

  async componentDidMount() {
    const { getDigitalCoachingTrainers, getWellnessPrograms, setCohortForm } = this.props;
    const { cohort } = this.state;

    if (cohort.program) {
      cohort.program_id = cohort.program.program;
      cohort.start_date = cohort.program.start_date || ''
    }
    else {
      cohort.program_id = '';
      cohort.start_date = '';
    }

    setCohortForm(cohort);

    const trainers = await getDigitalCoachingTrainers();
    const programs = await getWellnessPrograms();
    this.setState({ programs, trainers });
  }

  handleSubmit = async (form) => {
    const {
      createCohortProgram,
      updateCohortProgram,
      updateCompanyCohort,
    } = this.props;
    const { cohort } = this.state;

    await updateCompanyCohort(form.id, {
      name: form.name,
      trainer: form.trainer,
    });

    if (form.program_id !== cohort.program_id || form.start_date !== cohort.start_date) {
      if (form.program_id && !cohort.program_id) {
        await createCohortProgram({
          cohort: form.id,
          program: form.program_id,
          start_date: form.start_date,
        });
      }
      else {
        await updateCohortProgram(form.program.id, {
          program: form.program_id,
          start_date: form.start_date,
        });
      }
    }

    this.setState({ cohort: form });
  }

  addMember = (user) => {
    const { addMemberToCohort } = this.props;
    const { cohort, unassignedUsers } = this.state;

    addMemberToCohort(cohort.id, {
      members: [user.id]
    });

    const cohortMembers = [...cohort.members];
    cohortMembers.push(user);

    const companyUserIndex = unassignedUsers.findIndex(companyUser => companyUser.id === user.id);

    this.setState({
      cohort: {
        ...cohort,
        members: [...cohortMembers],
      },
      unassignedUsers: [...unassignedUsers.slice(0, companyUserIndex), ...unassignedUsers.slice(companyUserIndex + 1)],
    });
  }

  removeMember = (user) => {
    const { removeMemberFromCohort } = this.props;
    const { cohort, unassignedUsers } = this.state;

    removeMemberFromCohort(cohort.id, user.id);

    const cohortMemberIndex = cohort.members.findIndex(member => member.id === user.id)
    const cohortMembers = [...cohort.members.slice(0, cohortMemberIndex), ...cohort.members.slice(cohortMemberIndex + 1)];

    const newUnassigned = [...unassignedUsers];
    newUnassigned.push(user);

    this.setState({
      cohort: {
        ...cohort,
        members: [...cohortMembers],
      },
      unassignedUsers: newUnassigned,
    });
  }

  render() {
    const {
      companyState: {
        cohortMemberLoading,
        companyCohortUpdating,
        trainersLoading,
      }
    } = this.props;
    const {
      cohort,
      company,
      programs,
      trainers,
      unassignedUsers,
    } = this.state;

    return trainersLoading || trainers.length === 0 ? (
      <LoadingSpinnerPage />
    ) : (
      <Container>
        <Header>
          <Link to="/digital-coaching">Companies</Link> &raquo; <Link to={{ pathname: `/digital-coaching/${company.id}`, state: { company } }}>{company.name}</Link> &raquo; {cohort.name}
        </Header>
        <Detail
          companyCohortUpdating={companyCohortUpdating}
          initialValues={cohort}
          onSubmit={this.handleSubmit}
          programs={programs}
          trainers={trainers}
        />
        <Members
          addMember={this.addMember}
          cohort={cohort}
          cohortMemberLoading={cohortMemberLoading}
          removeMember={this.removeMember}
          users={unassignedUsers}
        />
      </Container>
    )
  }
}

CohortDetail.propTypes = {
};

CohortDetail.defaultProps = {
};

function mapStateToProps(state) {
  return {
    companyState: state.companyState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addMemberToCohort,
    createCohortProgram,
    getDigitalCoachingTrainers,
    getWellnessPrograms,
    removeMemberFromCohort,
    setCohortForm,
    updateCohortProgram,
    updateCompanyCohort,
  }, dispatch)
}


export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CohortDetail);
